export const enum BaseballSubParticipantStatId {
  Appearance = 35,
  GameStarted = 1229,
  CurrentPitcher = 1364,
  CurrentBatter = 1444,
  PitcherAppearance = 1471,
  PlateAppearance = 1472,
}
